import React from 'react';
import { FormikProps } from 'formik';

import usePrefix from 'utils/usePrefix';
import { CreateSchoolRequest } from 'utils/api/schools';

import Button from 'components/Button';
import DetailsTitle from 'components/DetailsTitle';
import FlexDiv from 'components/FlexDiv';
import LanguageSelect from 'components/LanguageSelect';
import ToggleSwitch from 'components/ToggleSwitch';
import { FormGroupStyled } from 'components/Forms/styles';
import InputField from 'components/InputField';

import {
  Content,
  ButtonsContainer,
  TextData,
  Subtitle,
  StyledFormField,
} from './styles';

interface Props {
  onClose: () => void;
}

const DetailsForm: React.FC<
  Pick<FormikProps<CreateSchoolRequest>, 'errors' | 'touched' | 'isSubmitting' | 'values'> & Props
> = ({ errors, touched, isSubmitting, onClose, values, ...props }) => {
  const t = usePrefix('General');

  return (
    <Content {...props} autoComplete="off">
      <FlexDiv justifyContent="space-between" alignItems="center">
        <TextData>
          {/* eslint-disable-next-line no-magic-numbers */}
          <DetailsTitle title={values.name || t('school_name')} empty={values.name.length < 1} />
          {/* eslint-disable-next-line no-magic-numbers */}
          <Subtitle empty={values.locality.length < 1}>{values.locality || t('locality')}</Subtitle>
        </TextData>
        <ButtonsContainer alignItems="center">
          <Button onClick={onClose} color="link">
            {t('dont_save_changes')}
          </Button>
          <Button label={t('save_changes')} type="submit" disabled={isSubmitting} />
        </ButtonsContainer>
      </FlexDiv>
      <FormGroupStyled>
        <InputField
          name="name"
          error={touched.name && errors.name}
          label={t('school_name')}
        />
        <InputField
          name="voivodeship"
          error={touched.voivodeship && errors.voivodeship}
          label={t('voivodeship')}
        />
        <InputField
          name="street"
          error={touched.street && errors.street}
          label={t('street')}
        />
        <InputField
          name="number"
          error={touched.number && errors.number}
          label={t('st_number')}
        />
        <InputField
          name="postal_code"
          error={touched.postal_code && errors.postal_code}
          label={t('postal_code')}
        />
        <InputField
          name="locality"
          error={touched.locality && errors.locality}
          label={t('locality')}
        />
        <LanguageSelect name="school_language" />
        <StyledFormField label={t('resql_expert')} margin={'0'}>
          <ToggleSwitch
            name="resql_expert_enabled"
            checked={values.resql_expert_enabled}
          />
        </StyledFormField>
      </FormGroupStyled>
    </Content>
  );
};

export default DetailsForm;
